<template>
    <div v-if="hasAccess">
        <top-nav-bar goto="/?page=pay-roll"></top-nav-bar>

        <div v-if="!loading" class="h-full">
            <div v-if="paySlips.length">
                <div class="mb-2">
                    <list>
                        <list-item class="text-base sm:text-xl" url="#"
                                   v-for="paySlip in paySlips" :key="paySlip.id"
                                   @click.native.prevent @click="download(paySlip)">
                            <template slot="icon">
                                <span class="relative">
                                    <i class="fa fa-file text-blue text-xl"></i>
                                    <span v-if="paySlip.id && $hasNotification('pay-slips', paySlip.id).length > 0"
                                          class="h-3 w-3 flex -ml-2 -mt-6 absolute pin-t pin-l bg-red rounded-full"
                                    ></span>
                                </span>
                            </template>
                            <template slot="title">
                                {{ formattedPeriod(paySlip) }}
                            </template>
                            <template slot="link-icon">
                                <i class="fal fa-download text-lg mr-2"></i>
                            </template>
                        </list-item>
                    </list>
                </div>
            </div>
            <div class="text-center p-4 text-grey-dark" v-else>
                You currently have no payslips.
            </div>
        </div>
        <div v-else class="h-full flex items-center justify-center pt-4">
            <div class="spinner-blue"></div>
        </div>
    </div>
</template>

<script>
    import CanAccessView from "../mixins/CanAccessView";
    import moment from "moment";

    export default {

        data() {
            return {
                loading: true,
                paySlips: [],
            }
        },

        mixins: [CanAccessView],

        mounted() {
            this.$api('pay-roll').get('pay-slips')
                .then(({data}) => {
                    this.paySlips = data.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        methods: {
            formattedPeriod(paySlip) {
                return moment(`${paySlip.year}-${paySlip.month}`, 'YYYY-MM').format('MMM Y');
            },

            download(paySlip) {
                this.processNotifications(paySlip);

                this.$swal({
                    title: 'Loading document content',
                    html: '<div class="loader"></div>',
                    showConfirmButton: false,
                });
                let url = 'pay-slips/download';
                if (paySlip && paySlip.id) {
                    url += '/' + paySlip.id;
                }
                let self = this;
                this.$api('pay-roll').get(url)
                    .then((response) => {
                        let data = response.data.data;
                        self.$swal.close();

                        // IE compatible
                        if (window.navigator.msSaveBlob) {
                            let byteString = atob(data);
                            let arrayBuffer = new ArrayBuffer(byteString.length);
                            let uint8Array = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < byteString.length; i++) {
                                uint8Array[i] = byteString.charCodeAt(i);
                            }
                            let blob = new Blob([arrayBuffer], {type: 'application/pdf'});
                            window.navigator.msSaveOrOpenBlob(blob, paySlip.file_name);
                        } else {
                            let element = document.createElement('a');
                            element.setAttribute('href', 'data:application/octet-stream;base64,' + data);
                            element.setAttribute('download', paySlip.file_name);
                            element.style.display = 'none';
                            document.body.appendChild(element);
                            element.click();
                            document.body.removeChild(element);
                        }
                    });
            },

            processNotifications(paySlip) {
                let notifications = this.$hasNotification('pay-slips', paySlip.id);

                if (notifications.length > 0) {
                    notifications.forEach(notification => this.$notificationRead(notification));
                }
            }
        },

    }
</script>
